// TODO: expose the env vars

export const SERVER_URL = 'https://api.ibetcha.gg';
//export const SERVER_URL = 'http://localhost:1337';
